import type { PERMISSION_GROUP_LIST_ALL } from "modules/auth";
import type { Customer } from "modules/customers";
import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";

export interface UserMetadata {
  termsAcceptanceDate?: string;
}

export default interface User extends ObjectWithId {
  name: string;
  email: string;
  permissions: PERMISSION_GROUP_LIST_ALL[];
  active: boolean;
  locked: boolean;
  twoFactorAuthentication?: boolean;
  customer?: Pick<Customer, "id" | "name" | "discr" | "active">;
  voltEmployee: boolean;
}

export interface CurrentUser extends User {
  lastSuccessfulLogin: string | null;
  metadata: UserMetadata;
}

export interface UserForm {
  id?: UUID;
  name: string;
  email: string;
  permissions: PERMISSION_GROUP_LIST_ALL[];
  customer?: UUID;
  newPassword?: string;
}

export interface UserPatch extends UserForm {
  active?: boolean;
  locked?: false;
  twoFactorAuthentication?: boolean;
}

export type BasicUser = ObjectWithId & {
  name: string;
  customerId: UUID;
};

export const PROPERTY_ACTIVE = "active";
export const PROPERTY_VOLT_ADMIN = "voltAdmin";
